import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-list-compress",
  "use": "icon-file-list-compress-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-list-compress\"><defs><style type=\"text/css\"></style></defs><path d=\"M160 960l0-864 320 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64-64 0 0 64 64 0 0 64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64-64 0 0-64 64 0 0-64 95.712 0 0 192.288 192.288 0 0 671.712-672 0zM544 576l-128 0 0 224 128 0 0-224zM512 766.016l-64 0 0-64 64 0 0 64zM672 96l7.84 0 152.16 152.16 0 5.856-160 0 0-158.016z\" p-id=\"6426\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-list-compress.svg
// module id = sFti
// module chunks = 20